import {FontFamilyNames} from '@/constants/font-family-names'
import {isGreekLanguageSelected} from '@/services/lang'

export const getFontFamilyName = (): FontFamilyNames => {
    return isGreekLanguageSelected() ? FontFamilyNames.segoeUI : FontFamilyNames.poppins
}
